import { UserRole } from '@hellodarwin/core/lib/features/entities/profile-entities';
import { MappedFlagsInfos } from '@hellodarwin/core/lib/features/providers/feature-flags-provider';

const ClientFeatureFlags: MappedFlagsInfos = {
  newProjectSubmission: {
    enabled:
      process.env.REACT_APP_FEATURE_FLAG_PROJECT_SUBMISSION_SELF_SERVE_V1 ===
      'true',
    minimalAllowedRole: UserRole.Default,
  },
};

export default ClientFeatureFlags;
